import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

export default function JobDescribtion(props) {
  const { jobid } = useParams();
  
  return <div>JobDescribtion</div>;
}
